/**
 * Session-only shadowing playhead (center line) offsets.
 * Not persisted — resets on navigation / explicit clear.
 *
 * Shared (subtitleSeparation off): one offset for both tracks.
 * Separated: main / second each keep their own temporary center line.
 */

export type ShadowingCenterSlot = 'main' | 'second';

let sharedOffsetPx = 0;
let mainOffsetPx = 0;
let secondOffsetPx = 0;

export function getShadowingCenterOffsetPx(
  slot: ShadowingCenterSlot,
  subtitleSeparation: boolean,
): number {
  if (!subtitleSeparation) return sharedOffsetPx;
  return slot === 'main' ? mainOffsetPx : secondOffsetPx;
}

export function setShadowingCenterOffsetPx(
  slot: ShadowingCenterSlot,
  subtitleSeparation: boolean,
  offsetPx: number,
): void {
  if (!subtitleSeparation) {
    sharedOffsetPx = offsetPx;
    return;
  }
  if (slot === 'main') mainOffsetPx = offsetPx;
  else secondOffsetPx = offsetPx;
}

export function resetShadowingCenterOffset(): void {
  sharedOffsetPx = 0;
  mainOffsetPx = 0;
  secondOffsetPx = 0;
}
